import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";

interface SubmitProgressDialogProps {
  isSubmitting: boolean;
  submissionSuccessful: boolean;
  submissionError: string | null;
  submissionProgress: { value: number; label: string } | null;
  onHide: () => void;
  onNavigateTo: () => void;
  successMessage?: string;
  successButtonLabel?: string;
  successHeader?: string;
  processHeader?: string;
  userUpdateInfoMessage?: string;
}

export const SubmitProgressDialog = ({
  isSubmitting,
  submissionSuccessful,
  submissionError,
  submissionProgress,
  onHide,
  onNavigateTo,
  successMessage = "Your assignment has been successfully created!",
  successButtonLabel = "Go to Assignments",
  successHeader = "Assignment Created",
  processHeader = "Creating Assignment",
  userUpdateInfoMessage = "",
}: SubmitProgressDialogProps) => {
  return (
    <Dialog
      id="submit-progress-dialog"
      data-testid="submit-progress-dialog"
      header={submissionSuccessful ? successHeader : submissionError ? "Error" : processHeader}
      visible={isSubmitting || submissionSuccessful || !!submissionError}
      onHide={() => {
        if (!isSubmitting) {
          onHide();
        }
      }}
      closable={!isSubmitting}
      closeOnEscape={!isSubmitting}
      dismissableMask={!isSubmitting}
      blockScroll
      maskStyle={{ backdropFilter: "blur(5px)" }}
      style={{ width: "400px" }}
      footer={
        submissionSuccessful ? (
          <Button
            id="navigate-button"
            data-testid="navigate-button"
            label={successButtonLabel}
            onClick={onNavigateTo}
          />
        ) : isSubmitting ? null : (
          <Button
            id="close-error-button"
            data-testid="close-error-button"
            label="Close"
            onClick={onHide}
          />
        )
      }
    >
      <div className="p-10 flex flex-col items-center">
        {isSubmitting ? (
          <>
            <ProgressBar
              id="submission-progress-bar"
              data-testid="submission-progress-bar"
              value={submissionProgress?.value ?? 0}
              showValue={false}
              style={{ height: "20px", width: "100%" }}
            />
            <p id="progress-label" data-testid="progress-label" className="mt-3">
              {submissionProgress?.label ?? "Processing..."}
            </p>
          </>
        ) : submissionSuccessful ? (
          <>
            <p id="success-message" data-testid="success-message">
              {successMessage}
            </p>
            {userUpdateInfoMessage && (
              <p id="user-update-info" data-testid="user-update-info" className="mt-3 body-sm">
                {userUpdateInfoMessage}
              </p>
            )}
          </>
        ) : submissionError ? (
          <p id="error-message" data-testid="error-message">
            Error: {submissionError}
          </p>
        ) : null}
      </div>
    </Dialog>
  );
};
